<template>
    <v-content>
        <welcome />
        <about />
    </v-content>
</template>

<script>
export default {
    name: "CoreView",

    components: {
        Welcome: () => import("@/components/Welcome"),
        About: () => import("@/components/About")
    }
};
</script>
